export default __webpack_public_path__ + "static/media/slider-2.9dbdf5c6.png";